"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var _excluded = ["label", "price", "unit", "color", "deleted"];

var _this = void 0;

/**
 * ChargeInfo.PriceInfo
 * @description 计费UI组件-表单项价格信息
 */
var PriceInfo = function PriceInfo(_ref) {
  (0, _newArrowCheck2["default"])(this, _this);
  var label = _ref.label,
      price = _ref.price,
      unit = _ref.unit,
      color = _ref.color,
      deleted = _ref.deleted,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_style.StyledPriceInfoWrapper, (0, _extends2["default"])({
    component: "div",
    size: "t1",
    lineHeight: "lg",
    color: color
  }, others), label, /*#__PURE__*/_react["default"].createElement("span", {
    style: deleted ? {
      textDecoration: "line-through"
    } : {}
  }, price ? price : "-", unit));
}.bind(void 0);

PriceInfo.propTypes = {
  /** 标题 */
  label: _propTypes["default"].string,

  /** 价格值 */
  price: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /** 表单项价格的单位 */
  unit: _propTypes["default"].string,

  /** 颜色 */
  color: _propTypes["default"].oneOf(["light", "dark"]),

  /**
   * 添加删除线样式
   */
  deleted: _propTypes["default"].bool
};
PriceInfo.defaultProps = {
  unit: "",
  color: "light"
};
var _default = PriceInfo;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ChargeInfo/PriceInfo.js
// module id = 2084
// module chunks = 6 7 17 18